'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SprocketMenu = function () {
  function SprocketMenu(options) {
    _classCallCheck(this, SprocketMenu);

    this.baseUrl = this.getHsBaseUrl(options.app_hs_base_url);
    this.contentId = options.page_id;
    this.categoryId = options.category_id;
    this.contentGroupId = options.content_group_id;
    this.portalId = options.portal_id;
  }

  _createClass(SprocketMenu, [{
    key: 'getHsBaseUrl',
    value: function getHsBaseUrl(baseUrl) {
      return window.localStorage.getItem('HS_LOCAL_TESTING') ? baseUrl.replace(/[^/](\w+?)(?=\.)/, 'local') : baseUrl;
    }
  }, {
    key: 'createElementFromHTML',
    value: function createElementFromHTML(htmlString) {
      var div = document.createElement('div');
      div.innerHTML = htmlString.trim();

      return div.firstChild;
    }
  }, {
    key: 'jsonp',
    value: function jsonp(url, callback) {
      window.jsonpHandler = function (data) {
        callback(data);
      };

      var src = '' + url + (url.indexOf('?') !== -1 ? '&' : '?') + 'callback=jsonpHandler';
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = src;
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  }, {
    key: 'showToolsMenuIfAuthor',
    value: function showToolsMenuIfAuthor() {
      var _this = this;

      // never show the tools menu in an iframe.
      if (window.location !== window.parent.location) {
        return;
      }

      var resourceName = void 0;
      var resourceId = this.contentId;
      var canPrefetchEditorForResource = false;

      if (this.contentId && this.contentGroupId) {
        if (this.categoryId === 6) {
          resourceName = 'knowledge-articles';
        } else {
          resourceName = 'blog-posts';
        }
      } else if (this.contentGroupId) {
        if (this.categoryId === 6) {
          resourceName = 'knowledge-bases';
        } else {
          resourceName = 'blogs';
        }

        resourceId = this.contentGroupId;
      } else if (this.categoryId === 1 && window.location.pathname.endsWith('_hcms/mem/login')) {
        resourceName = 'content-membership';
      } else {
        canPrefetchEditorForResource = true;
        resourceName = 'landing-pages';
      }

      var permissionUrl = this.baseUrl + '/content-tools-menu/api/v1/tools-menu/has-permission?portalId=' + this.portalId;

      this.jsonp(permissionUrl, function (data) {
        if (data.has_permission) {
          if (resourceName === 'content-membership') {
            _this.getContentMembershipCookie(resourceName, _this.portalId);
          } else {
            _this.getAppLinks(resourceName, resourceId, _this.portalId);
          }
          if (canPrefetchEditorForResource) {
            _this.setupDeferredPrefetchingOfEditorAssets(resourceName);
          }
        }
      });
    }
  }, {
    key: 'getContentMembershipCookie',
    value: function getContentMembershipCookie(resourceName, portalId) {
      var _this2 = this;

      this.jsonp(this.baseUrl + '/self-service-portal/v1/content/validate-hubspot-user?redirect_url=' + window.location.href + '&portalId=' + portalId, function (data) {
        if (data && data.verified) {
          var redirectUrl = _this2.getUrlParameter('redirect_url');
          window.location.href = redirectUrl === '' ? window.location.origin : redirectUrl;
        }
      });
    }
  }, {
    key: 'getAppLinks',
    value: function getAppLinks(resourceName, pk, portalId) {
      var _this3 = this;

      this.jsonp(this.baseUrl + '/content-tools-menu/api/v1/tools-menu/' + resourceName + '/' + pk + '/actions?portalId=' + portalId, function (data) {
        if (data.actions && data.strings) {
          _this3.showAppLinks(data.actions, data.strings);
        }
      });
    }
  }, {
    key: 'showAppLinks',
    value: function showAppLinks(actions, strings) {
      // Insert site maps link if there is a site map on the page
      var mapWidgets = [].slice.call(document.querySelectorAll('[data-menu-id]')).filter(function (element) {
        return !!element.getAttribute('data-menu-id').trim();
      });

      var mapWidget = mapWidgets.length > 0 ? mapWidgets[0] : null;
      if (mapWidget !== null) {
        var dataMenuId = mapWidget.getAttribute('data-menu-id').trim();
        actions.push([strings.EDIT_NAVIGATION_MENU, this.baseUrl + '/settings/' + this.portalId + '/website/navigation/' + dataMenuId]);
      }

      var links = '';
      actions.forEach(function (link) {
        links += '        <li><a target=\'_blank\' href=\'' + link[1] + '\'>\n        ' + link[0] + '\n        </a></li>      ';
      });

      var menu = '\n      <div class="hs-tools-menu hs-collapsed">\n        <img class="hs-sprocket" src="https://cdn2.hubspot.net/static/sprocket_white_80.png" />\n          <div class="hs-dropdown">\n          <div class="hs-title">HubSpot Tools</div>\n            <ul>\n              ' + links + '\n            <li class="hs-menu-hider"><a>' + strings.HIDE_THIS_MENU + '</a></li>\n            </ul>\n        </div>\n        </div>\n      ';

      document.body.appendChild(this.createElementFromHTML(menu));
      this.registerEvents();
    }
  }, {
    key: 'registerEvents',
    value: function registerEvents() {
      var element = document.querySelector('.hs-tools-menu');
      this.registerDropdown(element);

      element.querySelector('.hs-menu-hider').addEventListener('click', function (event) {
        event.stopPropagation();
        element.style.display = 'none';
      });
    }
  }, {
    key: 'registerDropdown',
    value: function registerDropdown(element) {
      var hideDropdown = function hideDropdown() {
        element.classList.add('hs-collapsed');
      };
      var showDropdown = function showDropdown() {
        element.classList.remove('hs-collapsed');
      };

      var bodyClickHandler = function bodyClickHandler() {
        hideDropdown();
        document.body.removeEventListener('click', bodyClickHandler);
      };

      var menuClickHandler = function menuClickHandler(event) {
        if (event.target.getAttribute('href')) {
          return;
        }
        event.preventDefault();
        event.stopPropagation();

        if (element.classList.contains('hs-collapsed')) {
          showDropdown();
          document.body.addEventListener('click', bodyClickHandler);
        } else {
          hideDropdown();
          document.body.removeEventListener('click', bodyClickHandler);
        }
      };
      element.addEventListener('click', menuClickHandler, false);
    }
  }, {
    key: 'getUrlParameter',
    value: function getUrlParameter(name) {
      name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    // Two seconds after window load, fetch a small script that in turn, appends
    // abunch of <link rel="prefetch"> tags to the page. The idea is to use the
    // idle time of the users page load to get a jump start on loading the heavy
    // assets of the editor. The prefetches are given the lowest priority by the
    // browser, so it hopefully doesn't interfere with the users page.
    // See https://developer.mozilla.org/en-US/docs/Web/HTTP/Link_prefetching_FAQ

  }, {
    key: 'setupDeferredPrefetchingOfEditorAssets',
    value: function setupDeferredPrefetchingOfEditorAssets(resourceName) {
      window.addEventListener('load', function () {
        setTimeout(function () {
          var prefetcherPath = void 0;
          if (resourceName === 'landing-pages') {
            prefetcherPath = 'content/editor/prefetcher.js';
          } else {
            return;
          }
          // Doing this to avoid relative domains, don't want to get 404s
          // when developing locally
          var domain = window.location.host.indexOf('hubspotqa') > -1 ? 'app.hubspotqa.com' : 'app.hubspot.com';

          var script = document.createElement('script');
          script.src = 'https://' + domain + '/' + prefetcherPath;
          document.head.appendChild(script);
        }, 2000);
      });
    }
  }]);

  return SprocketMenu;
}();

exports.default = SprocketMenu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/SprocketMenu.js
// module id = 2
// module chunks = 0 1